import './TagNameSection.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { SonarText } from '@ui/text';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY, TAG_NAME } from '@sonar-software/sonar-ts-constants';
import Form from 'antd/es/form';
import { Input, Space } from 'antd';
import React, { useCallback } from 'react';
import { useAction, useTagReference } from '@hooks';
const itemName = 'name';
const requiredRule = {
    message: TAG_NAME.REQUIRED_MESSAGE,
    required: true
};
const lengthRule = {
    max: TAG_NAME.MAX_LENGTH,
    message: TAG_NAME.MAX_MESSAGE,
    type: 'string'
};
const rules = [requiredRule, lengthRule];
export const TagNameSection = ({ tagId }) => {
    const tag = useTagReference(tagId);
    const form = useFormInstance();
    const requestPut = useAction(coreActions.requestPutCoreTagsById);
    const handleChange = useCallback(() => {
        const errors = form.getFieldError(itemName);
        const value = form.getFieldValue(itemName);
        if (tagId && !errors.length && value !== tag.name) {
            requestPut(Object.assign(Object.assign({}, tag), { name: form.getFieldValue(itemName) }));
        }
    }, [form, requestPut, tag, tagId]);
    return (React.createElement(Space, { className: 'tag-name-section', direction: 'vertical', size: 4 },
        React.createElement(SonarText, { size: 16, weight: 'semibold' }, COPY_SPECIFIC.NAME),
        React.createElement(Form.Item, { initialValue: tag.name, name: itemName, rules: rules },
            React.createElement(Input, { className: 'tag-name-input', disabled: tag.autoTagged, onBlur: handleChange, placeholder: PLACEHOLDERS_COPY.TAG_NAME }))));
};
